import { useEffect, useState } from "react";
import { convertPdfToImages } from "src/components/shared/ImageUploader/pdf.utils";

const ImageAttachment = ({ value }: { value: any }) => {
  const [pages, setPages] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      if (typeof value === "string" && value.includes("data:application/pdf")) {
        const pages = await convertPdfToImages(undefined, value);
        setPages(pages);
      }
    })();
  }, [value]);
  if (!value || typeof value !== "string") return null;
  if (value.includes("data:image")) {
    return (
      <img
        src={value}
        alt="attachment"
        width="100%"
        style={{ maxHeight: "600px" }}
      />
    );
  } else if (value.includes("data:application/pdf")) {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {pages.map((page, i) => (
          <img
            key={i}
            src={page}
            alt="attachment"
            style={{ maxHeight: "600px" }}
          />
        ))}
      </div>
    );
  }
  return null;
};
export default ImageAttachment;
